import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import throttle from 'lodash.throttle';

// components
import PageWrapper from '../../../../../../components/PageWrapper';
import ResizableContainerToggle from './components/ResizableContainerToggle';

// Styles
import './styles.scss';

// Selectors
// HACK path
import { selectUuids } from '../EventsTable/selectors';

const CLOSED_HEIGHT = 60;
const PADDING_OFFSET = 14;
const TOP_NAV_OFFSET = 50;

interface Props {
    children: React.Node;
    rows: string[];
}

interface State {
    open: boolean;
    maxHeight: number;
    tablet: boolean;
}

class ResizableContainer extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            open: true,
            maxHeight: 0,
            tablet: false
        };
        this.handleWindowResize = throttle(this.handleWindowResize, 300);
    }

    componentDidMount() {
        this.handleWindowResize();
        window.addEventListener('resize', this.handleWindowResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowResize);
    }

    get styles() {
        const { open, maxHeight, tablet } = this.state;
        const { rows } = this.props;
        const totalRows = rows.length || 1;
        const height = 160 + totalRows * 42; // base px + (total rows * row height);

        if (open && height > maxHeight) {
            const styles = {
                overflowY: 'auto',
                height: window.innerHeight - PADDING_OFFSET * 2
            };
            styles.height = tablet
                ? styles.height - TOP_NAV_OFFSET
                : styles.height;
            return styles;
        }

        if (open) {
            return { height };
        }

        return { height: CLOSED_HEIGHT };
    }

    handleWindowResize = () => {
        this.setState({
            maxHeight: window.innerHeight * 0.8, // 80% of window height
            tablet: window.innerWidth < 1024
        });
    };

    handleClick = () => {
        this.setState((state) => ({ open: !state.open }));
    };

    render() {
        const { children } = this.props;
        const { open } = this.state;

        return (
            <div
                // HACK inline styles
                style={{
                    position: 'relative',
                    zIndex: 1
                }}
            >
                <ResizableContainerToggle
                    handleClick={this.handleClick}
                    open={open}
                />
                <div className="resizable-container" style={this.styles}>
                    <PageWrapper top={16}>{children}</PageWrapper>
                </div>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    rows: selectUuids
});

export default connect(mapStateToProps)(ResizableContainer);
